import DataLayer from '@services/data-layer/index'

export const state = {
    byStation: {},
}

export const getters = {
    currentForStation: state => stationId => (state.byStation[stationId] || [])[0] || null,
}

export const mutations = {
    SET_BY_STATION(state, byStation) {
        state.byStation = byStation
    },
}

export const actions = {
    init({ commit }) {
        DataLayer.stationsPlaylists.subscribe(response => {
            const items = (response && response.body) || []
            const byStation = items.reduce((acc, item) => {
                if (!acc[item.station]) acc[item.station] = []
                acc[item.station].push(item)
                return acc
            }, {})
            commit('SET_BY_STATION', byStation)
        })
    },
}
